module.exports = __webpack_public_path__ + "img/nav1.a918db8f.png";